<template lang="pug">
div
	.listing-item(v-for='result in searchResults' :key='result.key')
			a.listing-item__heading(:target="result.openInNewWindow ? '_blank' : false" :href='result.url' :aria-label='getAriaText(result)')
				h4 {{result.title}}
			p.listing-item__intro(v-html='result.summary')


//- div
//-   .listing(v-for='result in searchResults' :key='result.key')
//-     .listing__content
//-       .listing__title
//-         a(:target="result.openInNewWindow ? '_blank' : false" :href='result.url' :aria-label='getAriaText(result)') {{result.title}}
//-       .listing__meta
//-         span.listing__meta-item.listing__file
//-           span(v-if='result.iconClass' :class='result.iconClass')
//-           | {{result.contentType}}
//-         span.listing__meta-item.listing__metadata(v-if='result.metadata1') {{result.metadata1}}
//-         span.listing__meta-item.listing__metadata(v-if='result.metadata2') {{result.metadata2}}
//-         span.listing__meta-item.listing__metadata(v-if='result.metadata3') {{result.metadata3}}
//-       .listing__description
//-         p {{result.summary}}

</template>

<script>
    export default {
        computed: {
            searchResults: function () {
                return this.$store.state.results.itemResults;
            },
            settings: function () {
                return this.$store.state.settings;
            },

        },
        methods: {
            getAriaText: function (item) {
                if (item != null) {
                    return "Click to go to " + item.title;
                } else {
                    return "";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.listing {
	width: 100%;
	display: block;
	padding-bottom: 1rem;
	margin-top: 1rem;
	border-bottom: dashed 1px $lightGray;
	&::after {
		content: '';
		display: table;
		clear: both;
	}
	&__img {
		float: right;
		width: 25%;
		max-width: 220px;
		min-width: 180px;
		padding: 0 0 0.75rem 1.5rem;
		@include mqdn(sm) {
			min-width: 33%;
			padding: 0 0 0.325rem 0.75rem;
		}
	}
	&__title {
		@include fluid(font-size, 1rem, 1.25rem);
		padding-bottom: 0.625rem;
		font-weight: 700;
		@include mqdn(sm) {
			padding-top: 0.25rem;
			padding-bottom: 1rem;
		}
		a {
			cursor: pointer;
		}
		p {
			margin-bottom: 0;
		}
	}
	&__meta {
		display: flex;
		margin-bottom: 0.875rem;
		font-size: 0.75rem;
		flex-wrap: wrap;
		color: palette(gray, 900);
		p {
			margin-bottom: 0;
		}
	}
	&__meta-item {
		display: flex;
		align-items: center;
		margin-bottom: 0.25rem;
		&:not(:last-child){
			&::after {
				content: '|';
				margin: 0 0.5rem;
			}
		}
	}
	&__meta-icon {
		width: 0.75rem;
		height: 0.75rem;
		margin-right: 0.25rem;
	}
	&__external-icon {
		padding-left: 0.25rem;
	}
	&__description {
		@include fluid(font-size, 0.875rem, 1rem);
		p {
			margin-bottom: 0.75rem;
		}
	}
	&__bottom-link a {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    &::after {
      content: '';
      height: 0.5em;
      width: 0.5em;
      border-top: 2px solid;
      border-left: 2px solid;
      transform: rotate(135deg);
      margin-left: 0.5em;
    }
	}
}

</style>